import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async createstation_owners(data) {
    let response = await apiCall("stationary_owners/create", data);
    return response;
  },
  async liststation_owners(data) {
    let response = await apiCall(
      "stationary_owners/list/stationary_owners",
      data
    );
    return response;
  },
  async liststation_owners_mini_data(data) {
    let response = await apiCall(
      "stationary_owners/list_stationOwners_mini_data",
      data
    );
    return response;
  },
  async get_station_company_name(data) {
    let response = await apiCall("stationary_owners/get_company_name", data);
    return response;
  },
  async updatestation_owners(data) {
    let response = await apiCall(
      "stationary_owners/update_stationary_owners",
      data
    );
    return response;
  },
};
